import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { getDashboardNotifications } from '../../../services/notificationService';

const AlertBanner = () => {
  const navigate = useNavigate();
  const [dismissedAlerts, setDismissedAlerts] = useState([]);
  const [alerts, setAlerts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadNotifications();
  }, []);

  const loadNotifications = async () => {
    try {
      setLoading(true);
      const notifications = await getDashboardNotifications();
      setAlerts(notifications || []);
    } catch (error) {
      console.error('Error loading notifications:', error);
      setAlerts([]);
    } finally {
      setLoading(false);
    }
  };

  const visibleAlerts = alerts?.filter(alert => !dismissedAlerts?.includes(alert?.id));

  const handleDismiss = (alertId) => {
    setDismissedAlerts([...dismissedAlerts, alertId]);
  };

  const handleAction = (actionRoute) => {
    if (actionRoute) {
      navigate(actionRoute);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center py-4">
        <div className="inline-block h-6 w-6 animate-spin rounded-full border-4 border-solid border-primary border-r-transparent"></div>
      </div>
    );
  }

  if (visibleAlerts?.length === 0) return null;

  return (
    <div className="space-y-3 md:space-y-4">
      {visibleAlerts?.map((alert) => (
        <div
          key={alert?.id}
          className={`
            rounded-lg border p-4 md:p-5 transition-smooth
            ${alert?.type === 'error' ? 'bg-error/5 border-error/20' : ''}
            ${alert?.type === 'warning' ? 'bg-warning/5 border-warning/20' : ''}
            ${alert?.type === 'success' ? 'bg-success/5 border-success/20' : ''}
          `}
        >
          <div className="flex items-start gap-3">
            <div className={`
              w-10 h-10 rounded-md flex items-center justify-center flex-shrink-0
              ${alert?.type === 'error' ? 'bg-error/10' : ''}
              ${alert?.type === 'warning' ? 'bg-warning/10' : ''}
              ${alert?.type === 'success' ? 'bg-success/10' : ''}
            `}>
              <Icon 
                name={alert?.icon} 
                size={20} 
                color={`var(--color-${alert?.type === 'success' ? 'success' : alert?.type === 'warning' ? 'warning' : 'error'})`}
              />
            </div>
            
            <div className="flex-1 min-w-0">
              <h3 className="font-body font-semibold text-sm md:text-base text-foreground mb-1">
                {alert?.title}
              </h3>
              <p className="caption text-muted-foreground mb-3">
                {alert?.message}
              </p>
              <Button
                variant="outline"
                size="sm"
                onClick={() => handleAction(alert?.actionRoute)}
                iconName="ArrowRight"
                iconPosition="right"
              >
                {alert?.actionLabel}
              </Button>
            </div>

            <button
              onClick={() => handleDismiss(alert?.id)}
              className="p-1 rounded-md hover:bg-muted transition-smooth flex-shrink-0"
              aria-label="Dismiss alert"
            >
              <Icon name="X" size={18} className="text-muted-foreground" />
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AlertBanner;